import { gql } from '@apollo/client';

export const SELLER_UPDATE_ORDER_STATUS = gql`
  mutation SellerUpdateOrderStatus($orderIds: [Int!]!, $orderStatus: String!) {
    sellerUpdateOrderStatus(orderIds: $orderIds, orderStatus: $orderStatus) {
      success
      message
      order_status
    }
  }
`;
